import { AfterViewInit, Directive, Input, OnDestroy, Renderer2, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[cwChangeTwcIconsSize]',
    standalone: false,
})
export class ChangeTwcIconsSizeDirective implements AfterViewInit, OnDestroy {
    @Input() cwTwcIconHeight = '32px';
    @Input() cwTwcIconWidth = '32px';

    private observer: MutationObserver = new MutationObserver(() => this.updateIconsSize());
    private nativeElement: any = this.viewContainer.element.nativeElement;

    constructor(
        private renderer: Renderer2,
        private viewContainer: ViewContainerRef
    ) {}

    ngAfterViewInit(): void {
        this.observer.observe(this.nativeElement, { attributes: true });

        this.updateIconsSize();
    }

    ngOnDestroy(): void {
        this.observer.disconnect();
    }

    private updateIconsSize(): void {
        const twcIconList: HTMLElement[] = this.nativeElement.querySelectorAll('twc-icon') ?? [];

        for (const twcIcon of twcIconList) {
            twcIcon.style.height = this.cwTwcIconHeight;
            twcIcon.style.width = this.cwTwcIconWidth;
        }
    }
}
